
// BackButtonHandler.js
import { useEffect, useState, useRef } from 'react';
import { Outlet, useLocation, useNavigate, useBlocker } from 'react-router-dom';

import { SessionManager,  } from '../components/ComponentsLibrary';

const BackButtonHandler = () => {

  const location = useLocation(); // ✅ Called at top level
  const navigate = useNavigate(); // ✅ Called at top level

  const getRandomFourDigitNumber = () => {
    return Math.floor(1000 + Math.random() * 9000);
  };
  let indexToAppendToUrl = getRandomFourDigitNumber();

  useEffect(() => {

    const basePath = location.pathname;
    const trapUrl = `${basePath}?idxLock=${indexToAppendToUrl}`;

    let indexToAppend = 0;
    // Push two entries to trap back/forward
    window.history.replaceState({ trap: true }, '', basePath);
    /* for (let i = 0; i < 10; i++) {
      indexToAppend = i;
      const pathUrl = `${basePath}?idxLock=${indexToAppend}`;
      const dummyPageName = `Page_${indexToAppend}`;
      window.history.pushState({ page: dummyPageName }, '', pathUrl);
    }  */
    window.history.pushState({ trap: true }, '', basePath);

    // Push dummy entry when entering the protected route
    const currentPath = SessionManager.GetValueFromSession(SessionManager.CurrentActivePageKey);
    //window.history.pushState({ noBackExits: true }, '', currentPath);

    const handlePopState = (event) => {
      let currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl + 1}`;
      let indexToAppendToUrl2 = 0;
      window.history.pushState({ trap: true }, '', currentPath);

      // Optional redirect
      setTimeout(() => {
        navigate(currentPath, { replace: false }); // redirect after re-trapping
      }, 50); // or 10ms for safety

      const basePath = location.pathname;
      const trapUrl = `${basePath}?idxLock=${indexToAppendToUrl}`;
      window.history.replaceState({ trap: true }, '', basePath);
      window.history.pushState({ trap: true }, '', trapUrl);

      /* 
            const currentPath = SessionManager.GetValueFromSession(SessionManager.CurrentActivePageKey);
            let currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl + 1}`;
            let indexToAppendToUrl2 = 0;
            window.history.pushState({ page: currentPath }, '', currentPathUrl);
            currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl2 + 1}`;
            //window.history.pushState({ trap: true }, '', currentPathUrl);
      
            navigate(currentPathUrl, { replace: false });
            window.history.pushState({ page: currentPath }, '', currentPathUrl);
            window.history.pushState({ page: currentPath }, '', currentPathUrl); */
      // const currentPathUrl2 = `${currentPath}?idxLock=4e3ft6`;

      // if (currentPath && currentPath !== location.pathname) {

      // }
      //window.history.pushState(null, null, lockedPath.current);
    };

    const handlePopState02 = (event) => {
      const currentPath = SessionManager.GetValueFromSession(SessionManager.CurrentActivePageKey);
      let currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl + 1}`;
      let indexToAppendToUrl2 = 0;
      window.history.pushState({ page: currentPath }, '', currentPathUrl);
      currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl2 + 1}`;
      //window.history.pushState({ trap: true }, '', currentPathUrl);

      navigate(currentPathUrl, { replace: false });
      window.history.pushState({ page: currentPath }, '', currentPathUrl);
      window.history.pushState({ page: currentPath }, '', currentPathUrl);
      // const currentPathUrl2 = `${currentPath}?idxLock=4e3ft6`;
      
      // if (currentPath && currentPath !== location.pathname) {

      // }
      //window.history.pushState(null, null, lockedPath.current);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, navigate]);

  return <Outlet />;
};

const PreventBackForward = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lockedPath = useRef(location.pathname);

  useEffect(() => {
    // Initial push to lock current page into history
    window.history.pushState({ locked: true }, '', location.pathname);

    const handlePopState = (event) => {
      // Re-lock history and redirect back if needed
      if (event.state?.locked) {
        // This state is already our dummy; ignore it
        return;
      }

      // Immediately restore the current path and reload it
      window.history.pushState({ locked: true }, '', lockedPath.current);
      navigate(lockedPath.current, { replace: true }); // 🔁 Force re-render to the correct content
      
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, navigate]);

  return <Outlet />;
};


const PreventBackButton = ({ redirectTo = '/fallback' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isNavigatingRef = useRef(false); // prevent re-triggering

  useEffect(() => {
    const currentPath = location.pathname;

    // Push dummy trap entry on mount
    window.history.pushState({ noBackExits: true }, '', currentPath);

    const handlePopState = (e) => {
      if (e.state?.noBackExits && !isNavigatingRef.current) {
        isNavigatingRef.current = true;

        // Push trap again to rebuild the trap entry
        window.history.pushState({ noBackExits: true }, '', currentPath);

        const currentPath = SessionManager.GetValueFromSession(SessionManager.CurrentActivePageKey);

        // Delay the navigation to ensure pushState completes first
        setTimeout(() => {
          navigate(currentPath);
          isNavigatingRef.current = false;
        }, 50);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, navigate, redirectTo]);

  return <Outlet />;
};


const HandlerUtility = {
    BackButtonHandler,
    PreventBackForward,
    PreventBackButton,
};

export default HandlerUtility;

export const usePreventBackForward = (blocked = true) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(location.pathname);
  let indexToAppendToUrl = 0;

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (!blocked) return;

    const handlePopState = () => {
      if (window.location.pathname !== currentPath) {
        // Use history.replaceState to change URL without navigation
        window.history.replaceState(null, '', currentPath);
      }
    };

    const handlePopState2 = (event) => {
      const currentPath = SessionManager.GetValueFromSession(SessionManager.CurrentActivePageKey);
      let currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl + 1}`;
      let indexToAppendToUrl2 = 0;
      window.history.pushState({ trap: true }, '', currentPathUrl);
      currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl2 + 1}`;
      window.history.pushState({ trap: true }, '', currentPathUrl);

      for (let i = 0; i < 10; i++) {
        indexToAppendToUrl2 = i;
        const pathUrl = `${currentPath}?idxLock=${indexToAppendToUrl2}`; 
      window.history.pushState({ trap: true }, '', pathUrl);
      } 
      currentPathUrl = `${currentPath}?idxLock=${indexToAppendToUrl2 + 1}`;
      window.history.pushState({ trap: true }, '', currentPathUrl);
      navigate(currentPathUrl, { replace: false });
      // const currentPathUrl2 = `${currentPath}?idxLock=4e3ft6`;
      
      // if (currentPath && currentPath !== location.pathname) {

      // }
      //window.history.pushState(null, null, lockedPath.current);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [blocked, currentPath]);
};